import DateAdapter from '@mui/lab/AdapterDayjs';
import LocalizationProvider from '@mui/lab/LocalizationProvider';

const DateProvider = ({children}) => (
  <LocalizationProvider dateAdapter={DateAdapter}>
    {children}
  </LocalizationProvider>
);

export default DateProvider;
